import { Heading, Text } from '@bq/web-components';

export function LoginPage() {
  return (
    <main style={{ padding: 'var(--bq-vt-large) var(--bq-page-padding)' }}>
      <Heading level={2}>Login</Heading>
      <Text size="r2" color="n700">
        Authentication coming soon.
      </Text>
    </main>
  );
}
